import { createSignal, Show, type JSX } from 'solid-js';
import { useBoxPassword } from '../lib/queries';
import { Button } from '../ui/Button';
import { Icon } from '../ui/Icon';
import { CopyLine } from './CopyLine';
import { ErrorAlert } from './states';

/** Admin password for the box portal, fetched only when asked for. */
export function BoxPassword(props: { boxId: string }): JSX.Element {
  const [shown, setShown] = createSignal(false);
  const password = useBoxPassword(() => props.boxId, shown);

  return (
    <div class="stack gap-3">
      <Show
        when={shown() && password.data}
        fallback={
          <Button variant="secondary" size="sm" loading={password.isFetching} onClick={() => setShown(true)}>
            <Icon name="key" />
            Show password
          </Button>
        }
      >
        {(data) => (
          <>
            <CopyLine text={data().password} label="Copy password" />
            <Button variant="ghost" size="sm" onClick={() => setShown(false)}>
              Hide
            </Button>
          </>
        )}
      </Show>
      <Show when={password.isError}>
        <ErrorAlert title="Could not load the password" error={password.error} />
      </Show>
      <span class="text-xs muted">
        Sign in to the box portal as <code>admin</code>.
      </span>
    </div>
  );
}
